import {
  CREATE_VENUE_FAILURE,
  CREATE_VENUE_INIT,
  CREATE_VENUE_SUCCESS,
  DELETE_VENUE_FAILURE,
  DELETE_VENUE_INIT,
  DELETE_VENUE_SUCCESS,
  GET_MY_VENUES_FAILURE,
  GET_MY_VENUES_INIT,
  GET_MY_VENUES_SUCCESS,
  GET_VENUES_FAILURE,
  GET_VENUES_INIT,
  GET_VENUES_SUCCESS,
  LINK_STRIPE,
  RESET_VENUES,
  UPDATE_VENUE_FAILURE,
  UPDATE_VENUE_INIT,
  UPDATE_VENUE_SUCCESS,
  VenuesActionTypes,
  VenuesState
} from "./types";

const initialState: VenuesState = {
  myVenues: {},
  venues: {},
  venueUsers: {},
  isGettingMyVenues: false,
  successGettingMyVenues: false,
  errorGettingMyVenues: null,
  isGettingVenues: false,
  successGettingVenues: false,
  errorGettingVenues: null,
  isCreatingVenue: false,
  successCreatingVenue: false,
  errorCreatingVenue: null,
  isUpdatingVenue: false,
  successUpdatingVenue: false,
  errorUpdatingVenue: null,
  isDeletingVenue: false,
  successDeletingVenue: false,
  errorDeletingVenue: null,
  linkStripe: null
};

export default function appReducer(
  state = initialState,
  action: VenuesActionTypes
) {
  switch (action.type) {
    case LINK_STRIPE:
      return {
        ...state,
        linkStripe: action.state
      };

    case GET_MY_VENUES_INIT:
      return {
        ...state,
        isGettingMyVenues: true
      };

    case GET_MY_VENUES_SUCCESS:
      return {
        ...state,
        isGettingMyVenues: false,
        successGettingMyVenues: true,
        myVenues: action.venues,
        venueUsers: {
          ...state.venueUsers,
          ...action.venueUsers
        }
      };

    case GET_MY_VENUES_FAILURE:
      return {
        ...state,
        isGettingMyVenues: false,
        successGettingMyVenues: false,
        errorGettingMyVenues: action.error
      };
    case GET_VENUES_INIT:
      return {
        ...state,
        isGettingVenues: true
      };

    case GET_VENUES_SUCCESS:
      return {
        ...state,
        isGettingVenues: false,
        successGettingVenues: true,
        venues: action.venues,
        venueUsers: {
          ...state.venueUsers,
          ...action.venueUsers
        }
      };

    case GET_VENUES_FAILURE:
      return {
        ...state,
        isGettingVenues: false,
        successGettingVenues: false,
        errorGettingVenues: action.error
      };

    case CREATE_VENUE_INIT:
      return {
        ...state,
        isCreatingVenue: true
      };

    case CREATE_VENUE_SUCCESS:
      return {
        ...state,
        isCreatingVenue: false,
        successCreatingVenue: true,
        myVenues: {
          ...state.myVenues,
          [action.venueId]: action.venueEntity
        }
      };

    case CREATE_VENUE_FAILURE:
      return {
        ...state,
        isCreatingVenue: false,
        successCreatingVenue: false,
        errorCreatingVenue: action.error
      };

    case UPDATE_VENUE_INIT:
      return {
        ...state,
        isUpdatingVenue: true
      };

    case UPDATE_VENUE_SUCCESS:
      return {
        ...state,
        isUpdatingVenue: false,
        successUpdatingVenue: true,
        myVenues: {
          ...state.myVenues,
          [action.venueId]: action.venue
        }
      };

    case UPDATE_VENUE_FAILURE:
      return {
        ...state,
        isUpdatingVenue: false,
        successUpdatingVenue: false,
        errorUpdatingVenue: action.error
      };

    case DELETE_VENUE_INIT:
      return {
        ...state,
        isDeletingVenue: true
      };

    case DELETE_VENUE_SUCCESS:
      const newMyVenues = Object.assign({}, state.myVenues);
      delete newMyVenues[action.venueId];

      return {
        ...state,
        isDeletingVenue: false,
        successDeletingVenue: true,
        myVenues: newMyVenues
      };

    case DELETE_VENUE_FAILURE:
      return {
        ...state,
        isDeletingVenue: false,
        successDeletingVenue: false,
        errorDeletingVenue: action.error
      };

    case RESET_VENUES:
      return initialState;

    default:
      return state;
  }
}
